import { deleteRequest, postRequest } from "../utils/fetch";

const basePath = "/ApiCore/WishlistApi";

export interface IWishlistItem {
	id: string;
	productCategoryCode?: string;
	predefinedProductNameAndPvc?: string;
}

export function addWishlistItem(
	productCategoryCode: string,
	predefinedProductNameAndPvc: string,
): Promise<IWishlistItem> {
	return postRequest(
		basePath + "/AddWishListItem",
		{ productCategoryCode, predefinedProductNameAndPvc },
		{ headers: { "Content-type": "application/json; charset=utf-8" } },
	).then((res) => res as IWishlistItem);
}

export function deleteWishlistItem(id: string): Promise<void> {
	return deleteRequest(
		basePath + "/DeleteWishListItem",
		{ id },
		{ headers: { "Content-type": "application/json; charset=utf-8" } },
	);
}
